import React from "react";
import AuthService from '../Auth/AuthService';
import AttendanceView from "../dashboard/AttendanceView";
import AdminDashboard from "../dashboard/AdminDashboard";


export default function UserHome() {
    let tokendata = AuthService.tokenInfoNew();
    let userId = tokendata?.Id;

    return (
        <div>
            {tokendata?.roles === "ADMIN" && (
                <AdminDashboard />
            )}
            {tokendata?.roles === "TEACHER" && (
                <AttendanceView empId={userId} user={tokendata} />
            )}
            {tokendata?.roles === "Marriage" && (
                { userId }
            )};
        </div>

    );
}
